<template>
<div class="movie-box">
    <div class="movie-box page-margin-bottom1" v-if="couponsList.length >= 1">
        <div class="item">
            <div>支付方式</div>
            <div class="page-margin-top3">

                        <!-- 点券支付 -->
                        <div
                            class="payItem acea-row row-middle"
                            :class="active === 'yue' ? 'on' : ''"
                            @click="payItem('yue')"
                            v-if="parseFloat(pay_price) <= parseFloat(money)"
                        >
                            <div class="page-text-center name acea-row row-center-wrapper">
                            <div
                                class="iconfont icon-icon-test"
                                :class="active === 'yue' ? 'bounceIn' : ''"
                            ></div>
                            点券支付
                            </div>
                            <div class="page-text-center tip">可用点券：{{ money || 0 }}</div>
                        </div>

                        <!-- 点券+微信组合支付 -->
                        <div v-else>
                            <div
                            class="payItem acea-row row-middle"
                            :class="active === 'zh' ? 'on' : ''"
                            @click="payItem('zh')"
                            >
                            <div class="page-text-center name acea-row row-center-wrapper">
                                <div
                                class="iconfont icon-icon-test"
                                :class="active === 'zh' ? 'bounceIn' : ''"
                                ></div>
                                组合支付
                            </div>
                            <div class="page-text-center tip">点券支付 <span style='color:red;font-size:0.3rem'>{{money}}</span>&nbsp;&nbsp;微信支付 <span style='color:red;font-size:0.3rem'>{{ weixin_price(parseFloat(pay_price) - parseFloat(money))}}</span></div>
                            </div>
                            <div
                            class="kydq"
                            :style="{ color: '#999', 'margin-top': '10px' }"
                            >
                            可用点券：{{ money || 0 }}
                            </div>
                        </div>

            </div>
            </div>
    </div>

    <div class="movie-box page-margin-bottom1" v-else>
        <div class="item">
            <div>支付方式</div>
            <div class="page-margin-top3">
                <router-link :to="'/user/bindcoupon'" class="binding" >
                    <div class="payItem acea-row row-middle">
                        <div class="page-text-center name acea-row row-center-wrapper">
                        绑定点券
                        </div>
                        <div class="page-text-center tip">点击绑定点券</div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { getCouponsUser } from "@api/movie";
import { getUserInfo } from "@api/user";
import { roundFun } from "@utils/movie.js";
import { isWeixin } from "@utils";

const _isWeixin = isWeixin();

export default {
    name: "PaymentComponent",
    props: {
        pay_price: "0",
        money: "0"
    },
    data: function () {
        return {
            couponsList: [],
            active: "",
            userInfo: {},
            from: _isWeixin ? "weixin" : "weixinh5",
        }
    },
    watch: {
        active: {
            handler (newVal) {
                let pay_info = {
                    from: this.from,
                    active: newVal
                };
                this.$emit('payType', pay_info);
            }
        },
        pay_price: function (val) {
            if (val) {
                this.getUserInfo();
            }
        }
    },
    mounted: function () {
        this.getCoupons();
    },
    methods: {
        weixin_price: function (n) {
            if (!n) return;
            let val = roundFun(n, 2);
            return val;
        },
        getCoupons: function () {
            getCouponsUser(0).then((res)=>{
                if (!res.data) return;
                this.couponsList = res.data;
            });
        },
        payItem: function(index) {
           this.active = index;
        },
        getUserInfo: function() {
            let _pay = parseFloat(this.pay_price);
            let _now = parseFloat(this.money);
            if (this.couponsList.length >= 1) {
                if( _pay <= _now) {
                    this.active = 'yue';
                } else if (_pay > _now) {
                    this.active = 'zh';
                }
            }
        },
    }
}
</script>

<style scoped>
.item{
  font-size: 0.3rem;
  color: #282828;
}
.payItem {
    border: 1px solid #eee;
    border-radius: 0.06rem;
    height: 0.86rem;
    width: 100%;
    margin-top: 0.2rem;
    font-size: 0.28rem;
    color: #282828;
}
.name {
    width: 30%;
    border-right: 1px solid #eee;
}
.tip {
    width: 70%;
    font-size: 0.26rem;
    color: #aaa;
}
.on {
    border-color: #fc5445;
    color: #e93323;
}
</style>